<template>
  <div>
    <page-header title="ساخت کاربر جدید"></page-header>

    <crud-generator :fields="fields" @submit="submit" name="customers"></crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";

export default {
  name: "CreateCustomer",

  components: {CrudGenerator, PageHeader},

  data() {
    return {
      fields: [],
    }
  },

  mounted() {
    this.fillFields()
  },

  methods: {
    fillFields() {
      this.fields = [
        {
          name: 'name',
          label: 'نام',
          cols: 6,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'phone_number',
          label: 'شماره موبایل',
          cols: 6,
          type: 'text',
          direction: 'ltr',
        },
      ]
    },

    submit(values) {
      this.$store.dispatch("createCustomer", values)
          .then(() => {
            this.$router.push('/customers')
          })
    },
  }
}
</script>

<style scoped>

</style>